module.exports = __webpack_public_path__ + "media/svg-new/icon-agendadas-ff5abe29.svg";